import React from 'react';
import { getLocale, t } from '../utils/i18n';

/** These times describe successful frontend reads, not backend snapshot freshness. */
export default function QueryStatus({ query, source }) {
  if (!query) return null;
  return <div className="admin-data-status" aria-live="polite">
    {source && <span>{source}</span>}
    {query.error ? <span className="text-red-200">{t('adminUi.emptyFailure')}{query.dataUpdatedAt ? ` · ${t('adminUi.previousData')}` : ''}</span> : query.isFetching ? <span>{t('common.loading')}</span> : null}
    {query.dataUpdatedAt > 0 && <span>{t('adminUi.dataUpdated')}: {new Date(query.dataUpdatedAt).toLocaleString(getLocale())}</span>}
  </div>;
}
